import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";

/**
 * Completes a Google/LinkedIn redirect.
 *
 * Sign-up used to be blocked here (both URLs pointed at `?error=no-account`),
 * which made OAuth sign-in-only. It now completes the sign-up transfer and
 * drops the new user into onboarding, where the backend provisions their
 * company and workspace. Returning users land on `/dashboard` as before —
 * the onboarding gate forwards them if they never finished.
 */
export const SSOCallbackPage = () => {
    return (
        <AuthenticateWithRedirectCallback
            signUpForceRedirectUrl="/onboarding"
            signInForceRedirectUrl="/dashboard"
        />
    );
};
